import moment from "moment";

// Convert response from API to WorkOrderEntryModel
export default function WorkOrderEntryModelBuilder(source) {
  const workOrder = {}; // WorkOrderEntryModel

  workOrder.id = source.WorkOrderID;
  workOrder.propertyId = source.WorkOrder.property.id;
  workOrder.propertyName = source.WorkOrder.property.subtitle;
  workOrder.propertyNumber = source.WorkOrder.property.title;
  workOrder.reference = source.WorkOrder.reference;
  workOrder.createdOn = source.WorkOrder.createdon
    ? Date.parse(source.WorkOrder.createdon)
    : null;
  workOrder.closedOn = source.WorkOrder.closedon
    ? Date.parse(source.WorkOrder.closedon)
    : null;
  workOrder.type = source.WorkOrder.type;
  workOrder.category = source.WorkOrder.workordercategory?.id;
  workOrder.categoryName = source.WorkOrder.workordercategory?.title;
  workOrder.subCategory = source.WorkOrder.workordersubcategory?.id;
  workOrder.subCategoryName = source.WorkOrder.workordersubcategory?.title;
  workOrder.state = source.state;
  workOrder.status = source.WorkOrder.status;
  if (source.WorkOrder.equipment && source.WorkOrder.equipment.id) {
    workOrder.asset = source.WorkOrder.equipment.Id;
  } else {
    workOrder.asset = null;
  }
  workOrder.faultDescription = source.WorkOrder.description
    ? source.WorkOrder.description
    : "";
  workOrder.siteId = source.WorkOrder.site.id;
  workOrder.siteName = source.WorkOrder.site.title;
  workOrder.territoryId = source.WorkOrder.territory?.id;
  workOrder.territoryName = source.WorkOrder.territory?.title;
  workOrder.customerId = source.WorkOrder.customer.id;
  workOrder.clientName = source.WorkOrder.customer.title;

  workOrder.workitemtemplateid = null;
  workOrder.workitemtemplateref = null;

  workOrder.name = source.WorkOrder.name ? source.WorkOrder.name : "";
  workOrder.reportername = source.WorkOrder.reportername
    ? source.WorkOrder.reportername
    : "";
  workOrder.ponumber = source.WorkOrder.ponumber
    ? source.WorkOrder.ponumber
    : "";
  workOrder.customername = source.WorkOrder.customerresidentname
    ? source.WorkOrder.customerresidentname
    : "";
  workOrder.customerphone = source.WorkOrder.customercontactnumber
    ? source.WorkOrder.customercontactnumber
    : "";
  workOrder.customeremail = source.WorkOrder.customeremailaddress
    ? source.WorkOrder.customeremailaddress
    : "";
  workOrder.customervulnerability = source.WorkOrder.customervulnerability
    ? source.WorkOrder.customervulnerability
    : "";
  workOrder.diagnosis = source.WorkOrder.diagnosis
    ? source.WorkOrder.diagnosis
    : "";

  workOrder.reportertype = source.WorkOrder.reportertype;
  workOrder.reporteremail = source.WorkOrder.reporteremailaddress
    ? source.WorkOrder.reporteremailaddress
    : "";
  workOrder.reportertelephone = source.WorkOrder.reporterphonenumber
    ? source.WorkOrder.reporterphonenumber
    : "";
  workOrder.agreedoutsidesla = source.WorkOrder.agreedoutsidesla;

  workOrder.slahours = source.WorkOrder.slahours;

  workOrder.workOrderItems = []; // WorkItemEditModel[]

  workOrder.cmvDueDate = source.WorkOrder.duedate;
  workOrder.cmvContactDate = source.WorkOrder.contactdate;

  workOrder.projectId =
    source.WorkOrder?.project?.id || source.WorkOrder?.project?.Id || "";
  workOrder.projectName =
    source.WorkOrder?.project?.subtitle ||
    source.WorkOrder?.project?.Subtitle ||
    "";

  workOrder.noAccessAttempts = source.WorkOrder.noaccessattempts;

  if (source.WorkItems) {
    source.WorkItems.forEach((nextItem) => {
      // eslint-disable-next-line no-console
      console.log("nextItem", nextItem);
      workOrder.workOrderItems.push({
        id: nextItem.workItemId,
        workitemcategoryid:
          nextItem.fieldValues.category?.id ||
          nextItem.fieldValues.category?.Id,
        workitemcategoryname:
          nextItem.fieldValues.category?.title ||
          nextItem.fieldValues.category?.Title,
        preferredAppointmentDate: nextItem.fieldValues.preferredappointmentdate
          ? moment(nextItem.fieldValues.preferredappointmentdate).toISOString()
          : moment().toISOString(),
        preferredAppointmentSlot: nextItem.fieldValues
          .preferredappointmenttimeslot
          ? nextItem.fieldValues.preferredappointmenttimeslot.id ||
            nextItem.fieldValues.preferredappointmenttimeslot.Id
          : "",
        preferredAppointmentSlotTitle: nextItem.fieldValues
          .preferredappointmenttimeslot
          ? nextItem.fieldValues.preferredappointmenttimeslot.title ||
            nextItem.fieldValues.preferredappointmenttimeslot.Title
          : "",
        appointmentConfirmed: nextItem.fieldValues.workitemagreement
          ? nextItem.fieldValues.workitemagreement.id ||
            nextItem.fieldValues.workitemagreement.Id
          : "WIA004",
        appointmentConfirmedTitle: nextItem.fieldValues.workitemagreement
          ? nextItem.fieldValues.workitemagreement.title ||
            nextItem.fieldValues.workitemagreement.Title
          : "Not Agreed",
        jobSpecificAccessNotes:
          nextItem.fieldValues.jobspecificaccessnotes || "",
        // Reconnection
        reconnectelectricity:
          nextItem.fieldValues.reconnectelectricitysupply === "Yes",
        reconnectheat: nextItem.fieldValues.reconnectheatsupply === "Yes",
        reconnecthotwater:
          nextItem.fieldValues.reconnecthotwatersupply === "Yes",

        // Disconnection
        disconnectelectricity:
          nextItem.fieldValues.disconnectelectricitysupply === "Yes",
        disconnectheat: nextItem.fieldValues.disconnectheatsupply === "Yes",
        disconnecthotwater:
          nextItem.fieldValues.disconnecthotwatersupply === "Yes",
        isCompleted: nextItem.isCompleted,
        workitemtemplateid: nextItem.workItemTemplateId,
        workitemtemplatedisplayname: nextItem.workItemTemplateDisplayName,

        propertyaccessnotes: nextItem.fieldValues.propertyaccessnotes || "",
        redflag: nextItem.fieldValues.redflag || false,
        workItemNotes: nextItem.fieldValues.workitemnotes || "",
        expectedParts: nextItem.fieldValues.expectedparts || "",
        faultyAssets: nextItem.fieldValues.faultyassets || "",
      });
    });
  }

  return workOrder;
}
